// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3ij1n","content":"styles_content__5SrtO","selectAll":"styles_selectAll__31BNx"};